<template>
    <div @keyup.esc="triggerCloseModal" tabindex="0" class="order-details-modal">
        <div class="modal-body">
            <div class="modal-inner">
                <div class="content-modal">
                    <div class="scroll-section">
                        <div class="flex-container">
                            <div class="ordered-items">
                                <div class="temp-class">
                                    <div class="left-side">
                                        <div class="order-number">
                                            <h4 id="orderID">Order ID #{{orderIdModal}}, <span>{{orderData.dateCreated}}</span></h4>
                                        </div>
                                        <div id="orderStatus" :class="['status', orderData.status.toLowerCase()]">
                                            <h4>Status</h4>
                                            <p>{{orderData.statusMessage}}</p>
                                        </div>
                                        <div class="order-details-client">
                                            <h4 class="client-header">Billing address</h4>
                                            <div class="client-data">
                                                <p><strong>{{orderData.companyName}}</strong></p>
                                                <p>{{orderData.companyAddress.address1}},</p>
                                                <p v-if="orderData.companyAddress.address2">{{orderData.companyAddress.address2}},</p>
                                                <p>{{orderData.companyAddress.city}},</p>
                                                <p>{{orderData.companyAddress.state}} {{orderData.companyAddress.postalCode}}, {{orderData.companyAddress.country}}</p>
                                            </div>
                                        </div>
                                        <div class="order-details-client">
                                            <h4 class="client-header">Ship to:</h4>
                                            <div class="order-ship-address">
                                                <p>{{orderData.shippingAddress.addressLine1}}</p>
                                                <p>{{orderData.shippingAddress.addressLine2}},</p>
                                                <p>{{orderData.shippingAddress.city}},</p>
                                                <p>{{orderData.shippingAddress.state}} {{orderData.shippingAddress.postalCode}}, {{orderData.shippingAddress.country}}</p>
                                            </div>
                                        </div>

                                        <div v-if="orderData.wasPaidByCreditCard && orderData.creditCardInfo" :class="['order-details-client', orderData.status == 'PAYMENT_ERROR' ? 'payment-error' : '']">
                                            <h4 class="client-header">Payment Method</h4>
                                            <div class="credit-card">
                                                <img class="credit-card-image" :src="require('../../assets/img/' + orderData.creditCardInfo.cardImg)" alt="credit-card-logo" />
                                                <span class="credit-card-number"> {{orderData.creditCardInfo.cardDescription}}</span>
                                            </div>
                                            <div v-if="orderData.status == 'PAYMENT_ERROR' && typeAccount == 'PREPAID'" class="change-card-button">
                                                <button class="btn btn-primary" @click="changeCreditCard()">Change credit card</button>
                                                <div v-if="creditCardChange" class="change-credit-cards-box">
                                                    <div class="change-cc-header">
                                                        <h3>Select card</h3>
                                                        <i class="fa fa-close" @click="changeCreditCard()"></i>
                                                    </div>
                                                    <div class="cc-list">
                                                        <div v-for="card in cardsList" :class="['credit-card-select', card.creditCardId == orderData.creditCardInfo.creditCardId ? 'card-already-selected' : '']" @click="setNewCC(card.creditCardId)">
                                                            <img :src="require('../../assets/img/' + card.cardImg)" alt="cc-logo">
                                                            <span class="cc-number">.. {{card.cardNumber}}</span>
                                                            <span class="cc-nickname">{{card.nickName}}</span>
                                                        </div>
                                                    </div>
                                                    <p class="instruction">The selected Credit card, if not set to default in Payment Settings, will only be used for this transaction.</p>
                                                </div>
                                            </div>
                                            <span v-if="orderData.status == 'PAYMENT_ERROR'" class="payment-error-msg">The Payment could not be processed</span>
                                        </div>
                                        <div v-else-if="orderData.wasPaidByCreditCard && orderData.creditCardInfo == undefined" class="order-details-client">
                                            <h4 class="client-header">Payment Method</h4>
                                            <h5>Credit card has been removed from the system.</h5>
                                        </div>
                                        <div class="trackingNumber">
                                            <h4>Tracking Number</h4>
                                            <div v-if="orderData.trackingNumbers != undefined">
                                                <p v-for="number in orderData.trackingNumbers">
                                                    {{number}}
                                                </p>
                                            </div>
                                            <p v-else>-</p>
                                        </div>
                                    </div>
                                    <div class="right-side">
                                        <div class="cross-close-box">
                                            <button class="closeButton" v-on:click="triggerCloseModal">
                                                <i class="fa fa-close fa-lg"></i>
                                            </button>
                                        </div>
                                        <div class="summary-table-wrapper">
                                            <table class="summary-table">
                                                <thead>
                                                <tr>
                                                    <th>Pos</th>
                                                    <th>Carrier</th>
                                                    <th>Type</th>
                                                    <th>Item</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Total</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,i) in orderData.orderItems" v-bind:key="item.item.id" v-if="item.itemQuantity > 0" class="cost-row">
                                                        <td>{{i+1}}</td>
                                                        <td>
                                                            <div v-if="item.item.carrier.carrierId != 1" class="carrier-logo-box">
                                                                <img :src="item.item.lightCarrierImage" :alt="'light logo'" class="carrier-logo light-mode">
                                                                <img :src="item.item.darkCarrierImage" :alt="'dark logo'" class="carrier-logo dark-mode">
                                                            </div>
                                                            <div v-else class="carrier-logo-box">
                                                                <img src="./../../assets/img/simon-carrier.svg" alt="" class="carrier-logo light-mode">
                                                                <img src="./../../assets/img/simon-carrier-dark.svg" alt="" class="carrier-logo dark-mode">
                                                            </div>
                                                        </td>
                                                        <td v-if="item.item.carrier.carrierId == 1">
                                                            <span class="type flex" v-if="item.item.id == 4">FLEX</span>
                                                            <span class="type nb-iot" v-else-if="item.item.id == 5">NB-IOT</span>
                                                            <span class="type cat-m1" v-else-if="item.item.id == 6">CAT-M1</span>
                                                            <span v-else>N/A</span>
                                                        </td>
                                                        <td v-else>-</td>
                                                        <td>Blank SIM cards</td>
                                                        <td class="quantity">{{item.itemQuantity}}</td>
                                                        <td>{{item.item.unitPrice}}</td>
                                                        <td>{{item.itemPriceTotal}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <h4 v-if="orderData.taxApplied">Tax</h4>
                                        <div v-if="orderData.taxApplied" class="order-tax">
                                            <span>NYS Sales Tax</span>
                                            <span id="orderTax">$ {{orderData.taxApplied}}</span>
                                        </div>
                                        <h4>Shipment</h4>
                                        <div class="order-shipment">
                                            <span>{{orderData.shippingOption.displayName}}</span>
                                            <span>$ {{orderData.shippingOption.price}}</span>
                                        </div>
                                        <h4>Total cost</h4>
                                        <div class="order-total">
                                            <span v-if="orderData.taxApplied">Total cost summary with tax and shipping</span>
                                            <span v-else>Total cost summary with shipping</span>
                                            <h3>$ {{orderData.totalPrice}}</h3>
                                        </div>
                                        <div v-if="orderData.status == 'PAYMENT_ERROR' && typeAccount == 'PREPAID'" class="re-attempt-payment-box">
                                            <span>The Payment could not be processed, please try again, you can also check your <a @click="goToPaymentSettings()">Payment Settings</a></span>
                                            <button class="btn btn-primary" @click="reattemptPayment()">Re-attempt Payment</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="close-btn-box">
                                    <button @click="triggerCloseModal()" class="btn-close">Close</button>
                                </div>
                                <div class="loader-order-data" v-if="loading">
                                    <div class="loading-order-data-inner">
                                        <div class="sk-wave">
                                            <div class="sk-rect sk-rect1"></div>&nbsp;<div class="sk-rect sk-rect2"></div>&nbsp;<div class="sk-rect sk-rect3"></div>&nbsp;<div class="sk-rect sk-rect4"></div>&nbsp;<div class="sk-rect sk-rect5"></div>&nbsp;
                                        </div>

                                        <div class="text">
                                            Getting order data...
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Axios from 'axios';
import globalStore from '../../variables';
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)


export default {
    name: 'OrderDetailsModal',
    props: {
        orderIdModal: 0,
        closeModal: ''
    },
    data() {
        return {
            orderData: {
                orderId: null,
                companyId: null,
                orderItems: [],
                totalprice: null,
                priceBeforeTaxation: null,
                taxApplied: null,
                currency: null,
                creditCardInfo: {
                    creditCardInfo: null,
                    cardDescription: '',
                    cardImg: 'MasterCard-icon.svg',
                    cardNumber: '0'
                },
                shippingAddress: {
                    id: null,
                    addressName: null,
                    contactNumber: null,
                    addressLine1: null,
                    city: null,
                    postalCode: null,
                    country: null,
                    state: null
                },
                shippingOption: {
                    id: null,
                    displayName: null,
                    range: null,
                    price: 0,
                    sortOrder: null,
                    shippingDays: null
                },
                dateCreated: null,
                status: '',
                statusMessage: null,
                postPaid: false,
                companyName: null,
                companyAddress: {
                    city: "",
                    postalCode: "",
                    country: "",
                    phoneNumber: "",
                    state: "",
                    defaultAddress: null,
                    address1: "",
                    address2: ""
                },
                suppressEmails: false,
                loading: true
            },
            typeAccount: this.$cookies.get('typeAccount'),
            creditCardChange: false,
            cardsList: []
        }
    },
    methods: {
        getOrderDetails() {
            this.loading = true;
            Axios.get(globalStore.data.restApiUrl + '/orders/' + this.orderIdModal)
                .then(response => {
                    this.orderData = response.data;

                    if (this.orderData.taxApplied) {
                        this.orderData.taxApplied = this.orderData.taxApplied.toFixed(2)
                    }

                    for (let item of this.orderData.orderItems) {
                        item.itemPriceTotal = (item.item.unitPrice * item.itemQuantity).toFixed(2)
                        item.item.unitPrice = item.item.unitPrice.toFixed(2)
                    }

                    this.orderData.shippingOption.price = this.orderData.shippingOption.price.toFixed(2)
                    this.orderData.totalPrice = this.orderData.totalPrice.toFixed(2)

                    if (this.orderData.postPaid == false && this.orderData.creditCardInfo != undefined) {
                        let cardDesc = this.orderData.creditCardInfo.cardDescription;

                        let cardImg = cardDesc.substring(0, cardDesc.indexOf('*'));
                        let cardNum = cardDesc.substring(cardDesc.indexOf('*') +5 , cardDesc.length);
                        if (cardImg == 'Visa') {
                                cardImg = 'Visa-icon.svg'
                            } else if (cardImg == 'MasterCard') {
                                cardImg = 'MasterCard-icon.svg'
                            } else if (cardImg == 'Discover') {
                                cardImg = 'Discover-icon.svg'
                            } else if (cardImg == 'JCB') {
                                cardImg = 'JCB-icon.svg'
                            } else if (cardImg == 'American Express') {
                                cardImg = 'American Express-icon.svg'
                            } else if (cardImg == 'Diners Club') {
                                cardImg = 'dinersclub-icon.svg'
                            } else if (cardImg == 'UnionPay') {
                                cardImg = 'unionpay-icon.svg'
                            } else {
                                cardImg = 'defaultCard-icon.svg'
                            }
                        this.orderData.creditCardInfo.cardImg = cardImg;
                        this.orderData.creditCardInfo.cardNumber = cardNum;
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }

                    if (this.orderData.status == 'PAYMENT_ERROR') {
                        this.getCreditCards();
                    }
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Order Details - Contact Support',
                        duration: 5000,
                    })
                    this.loading = false;
                    console.log(error)
                })
        },
        triggerCloseModal(ev) {
            this.$emit('closeModal')
        },
        triggerRefreshList() {
            this.$emit('refreshList')
        },
        goToPaymentSettings() {
            this.$router.push('/settings/payment')
        },
        getUnitPrice() {
            Axios.get(globalStore.data.restApiUrl + '/orders/unit-price')
                .then(response => {
                    this.unitPrice = response.data
                }).catch(error => {
                    this.$notify({
                        type: 'warn',
                        group: 'notification',
                        title: 'Getting data error',
                        text: 'Error Retrieving Pricing Details - Contact Support',
                        duration: 5000,
                    });
                    console.log(error)
                })
        },
        setTimeToLocal (data) {
            let dateHistoryTime = new Date(data.getTime());

            if (dateHistoryTime.getHours() > 12) {
                let tempHour = (dateHistoryTime.getHours() + 24) % 12 || 12;
                if (dateHistoryTime.getMinutes() == 59) {
                    var hoursHistory = tempHour + ':' + ("0" + dateHistoryTime.getMinutes()).slice(-2) + ' PM'
                } else {
                    var hoursHistory = tempHour + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' PM'
                }
            } else {
                if (dateHistoryTime.getHours() == 0) {
                    var hoursHistory = '12' + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                } else {
                    var hoursHistory = dateHistoryTime.getHours() + ':' + ("0" + (dateHistoryTime.getMinutes() + 1)).slice(-2) + ' AM'
                }
            }

            let finalDate = data.getMonth() + 1 + '/' + data.getDate() + '/' + data.getFullYear() + ' ' + hoursHistory;
            return finalDate;
        },
        reattemptPayment() {
            Axios.patch( globalStore.data.restApiUrl + '/orders/reprocess-payment?orderId=' + this.orderIdModal)
                .then(response => {
                    this.triggerRefreshList();
                    this.triggerCloseModal()
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Your payment re-attempted',
                        text: 'We are trying to get payment for your order once more, please check it soon.',
                        duration: 5000,
                    })
                })
                .catch(error => {
                    this.$notify({
                        type: 'error',
                        group: 'notification',
                        title: 'Payment re-attempting failed',
                        text: 'An error has occured during getting payment. Please, contact support.',
                        duration: 5000,
                    })
                })
        },
        getCreditCards() {
            Axios.get(globalStore.data.restApiUrl + '/account/credit-card')
                .then(response => {
                    this.cardsList = [];
                    let parse = response.data
                    for (let card of parse) {
                        let cardDescTemp = card.card_desc
                        let cardImg = card.card_desc.substring(0, card.card_desc.indexOf('*'));
                        let cardNum = card.card_desc.substring(card.card_desc.indexOf('*') +5 , card.card_desc.length);
                        if (cardImg == 'Visa') {
                            cardImg = 'Visa-icon.svg'
                        } else if (cardImg == 'MasterCard') {
                            cardImg = 'MasterCard-icon.svg'
                        } else if (cardImg == 'Discover') {
                            cardImg = 'Discover-icon.svg'
                        } else if (cardImg == 'JCB') {
                            cardImg = 'JCB-icon.svg'
                        } else if (cardImg == 'American Express') {
                            cardImg = 'American Express-icon.svg'
                        } else if (cardImg == 'Diners Club') {
                            cardImg = 'dinersclub-icon.svg'
                        } else if (cardImg == 'UnionPay') {
                            cardImg = 'unionpay-icon.svg'
                        } else {
                            cardImg = 'defaultCard-icon.svg'
                        }

                        this.cardsList.push(
                            {
                                cardDesc: cardDescTemp,
                                creditCardId: card.creditCardId,
                                cardImg: cardImg,
                                cardNumber: cardNum,
                                exp_date: card.exp_date,
                                defcard: card.defcard,
                                nickName: card.nickName
                            }
                        )

                        if (card.defcard != 0) {
                            this.defCard = card.creditCardId;
                            this.defCardDesc = cardDescTemp;
                            this.hasDefCard++;
                        }
                    }
                }).catch(error => {
                this.$notify({
                    type: 'error',
                    group: 'notification',
                    title: 'Error',
                    text: 'Error Retrieving Credit Card Details - Contact Support',
                    duration: 5000,
                });
                console.log(error)
            })
        },
        changeCreditCard() {
            this.creditCardChange = !this.creditCardChange
        },
        setNewCC(ccId) {
            Axios.patch(globalStore.data.restApiUrl + '/orders/change-credit-card?orderId='+ this.orderIdModal + '&ccId=' + ccId)
                .then(response => {
                    this.getOrderDetails();
                    this.changeCreditCard();
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Credit card changed',
                        text: 'Credit card has been successfully changed for this order.',
                        duration: 5000,
                    });
                })
                .catch(error => {
                    this.$notify({
                        type: 'success',
                        group: 'notification',
                        title: 'Credit card change failed',
                        text: 'Credit card has not been changed for this order, please contact support.',
                        duration: 5000,
                    });
                    console.log(error)
                })
        }
    },
    created() {
        this.getOrderDetails();
        if (this.$cookies.get('typeAccount')) {
            this.typeAccount = this.$cookies.get('typeAccount')
        } else {
            this.typeAccount = this.$session.get('typeAccount')
        }

        document.onkeydown = evt => {
            evt = evt || window.event;
            if (evt.keyCode == 27) {
                this.triggerCloseModal()
            }
        };

    },
    beforeDestroy() {
        this.$emit('closeOrderModal');
    }
}
</script>

<style lang="scss" scoped>


    .order-details-modal {
        display: flex;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: fixed;
        width: 100vw;
        height: 100vh;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        background-color: rgba(44, 44, 44, 0.9);
        z-index: 3030;

        &.wrapper-disable {
            display: none;
        }

        .modal-body {
            position: relative;
            max-width: 80%;
            width: 100%;
            margin: 20px 0;
            padding: 0;
            background: #fff;
            box-shadow: 0 3px 6px rgba(0, 0, 0,.16);
            border-radius: 5px;

            .content-modal {
                .flex-container {
                    .ordered-items {
                        position: relative;
                        .temp-class {
                            display: flex;
                            flex-wrap: nowrap;
                            .left-side {
                                width: 30%;
                                padding: 20px;
                                margin-right: 20px;
                                border-right: 1px solid #c9cfd4;

                                .order-number {
                                    h4 {
                                        font-size: 15px;
                                        span {
                                            font-weight: 400;
                                        }
                                    }
                                }

                                .status {
                                    padding: 20px;
                                    margin-bottom: 20px;
                                    color: #ffffff;
                                    border: 1px solid #C9CFD4;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;

                                    &.complete {
                                        background-color: #55cd6c;
                                    }

                                    &.confirmed {
                                        background-color: #00b1ff;
                                    }

                                    &.created {
                                        background-color: #727a82;
                                    }

                                    &.cancelled {
                                        background-color: #000000;
                                    }

                                    &.packed {
                                        background-color: #0072cb;
                                    }

                                    &.paid {
                                        background-color: #0088ff;
                                    }

                                    &.payment_error {
                                        background-color: #fc4d4d;
                                    }

                                    &.shipped {
                                        background-color: #0050db;
                                    }

                                    h4 {
                                        font-size: 15px;
                                        margin: 0;
                                        margin-bottom: 20px;
                                        text-transform: uppercase;
                                    }
                                    p {
                                        font-size: 14px;
                                        margin: 0;
                                    }
                                }
                                .order-details-client {
                                    padding: 20px;
                                    margin-bottom: 20px;
                                    border: 1px solid #C9CFD4;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;

                                    &.payment-error {
                                        position: relative;
                                        border-color: #fc4d4d;
                                    }

                                    .payment-error-msg {
                                        position: absolute;
                                        top: 100%;
                                        left: 0;
                                        font-size: 12px;
                                        color: #fc4d4d;
                                    }

                                    h4 {
                                        font-size: 15px;
                                        margin: 0;
                                        margin-bottom: 20px;
                                    }

                                    h5 {
                                        font-size: 15px;
                                        margin: 0;
                                    }



                                    .client-data,
                                    .order-ship-address {
                                        p {
                                            margin: 0;
                                        }
                                    }

                                    .credit-card {
                                        display: flex;
                                        align-items: center;
                                        padding: 4px 20px 4px 4px;

                                        .credit-card-image {
                                            margin-right: 11px;
                                        }

                                        .credit-card-number {
                                            margin-right: 20px;
                                        }

                                        .credit-card-default {
                                            flex-grow: 1;
                                            text-align: right;
                                        }
                                    }
                                    .change-card-button {
                                        position: relative;
                                        margin-top: 12px;
                                        .change-credit-cards-box {
                                            position: absolute;
                                            bottom: 0;
                                            left: 50%;
                                            min-width: 380px;
                                            padding: 20px;
                                            background-color: #fff;
                                            border: 1px solid #c9cfd4;
                                            -webkit-border-radius: 5px;
                                            -moz-border-radius: 5px;
                                            border-radius: 5px;
                                            z-index: 10;
                                            .change-cc-header {
                                                display: flex;
                                                justify-content: space-between;
                                                margin: 0 0 20px;
                                                h3 {
                                                    font-size: 15px;
                                                    margin: 0;
                                                }
                                                i {
                                                    cursor: pointer;
                                                }
                                            }
                                            .cc-list {
                                                display: flex;
                                                flex-direction: column;
                                                .credit-card-select {
                                                    display: flex;
                                                    align-items: center;
                                                    margin: 0 0 12px 0;
                                                    padding: 4px;
                                                    border: 1px solid #C9CFD4;
                                                    -webkit-border-radius: 5px;
                                                    -moz-border-radius: 5px;
                                                    border-radius: 5px;
                                                    cursor: pointer;

                                                    &.card-already-selected {
                                                        display: none;
                                                    }

                                                    &:hover {
                                                        border-color: #0088ff;
                                                    }

                                                    img {
                                                        margin-right: 12px;
                                                    }

                                                    .cc-number {
                                                        margin-right: 20px;
                                                    }

                                                    .cc-nickname {
                                                        color: #a4a6a8;
                                                    }
                                                }
                                                .instruction {
                                                    color: #515B65;
                                                    font-size: 12px;
                                                    line-height: 20px;
                                                }
                                            }
                                        }
                                    }
                                }
                                .trackingNumber {
                                    padding: 20px;
                                    border: 1px solid #C9CFD4;
                                    -webkit-border-radius: 5px;
                                    -moz-border-radius: 5px;
                                    border-radius: 5px;
                                    h4 {
                                        font-size: 15px;
                                        margin: 0;
                                        margin-bottom: 20px;
                                    }
                                    p {
                                        font-size: 14px;
                                        margin: 0;
                                    }

                                }
                            }
                            .right-side {
                                flex-grow: 1;
                                display: flex;
                                flex-direction: column;
                                padding: 20px 20px 20px 0;

                                .cross-close-box {
                                    display: flex;
                                    justify-content: flex-end;
                                    border: none;

                                    .closeButton {
                                        background-color: transparent;
                                        border: 0;
                                        outline: none;
                                        i {
                                            margin: 0;
                                        }
                                    }
                                }

                                h4 {
                                    margin-top: 18px;
                                    font-size: 14px;
                                    font-weight: 700;
                                }

                                div {
                                    display: flex;
                                    justify-content: space-between;
                                    padding-bottom: 20px;
                                    border-bottom: 1px solid #dfe2e5;
                                }



                                .summary-table {
                                    width: 100%;

                                    th {
                                        padding-bottom: 10px;

                                        &:first-child {
                                            padding-left: 10px;
                                        }
                                        &:last-child {
                                            padding-right: 10px;
                                        }
                                    }

                                    th {
                                        &:nth-child(1) {
                                            width: 14%;
                                        }

                                        &:nth-child(2) {
                                            width: 16%;
                                        }

                                        &:nth-child(3) {
                                            width: 14%;
                                        }

                                        &:nth-child(4) {
                                            width: 14%;
                                        }

                                        &:nth-child(5) {
                                            width: 14%;
                                        }

                                        &:nth-child(6) {
                                            width: 14%;
                                        }

                                        &:nth-child(7) {
                                            width: 14%;
                                        }
                                        &:nth-child(7) {
                                            text-align: right;
                                        }
                                    }


                                    tbody {
                                        border-top: 1px solid #dfe2e5;
                                        border-bottom: 1px solid #dfe2e5;

                                        tr {
                                            &:nth-child(even) {
                                                background-color: #f0f3f5;
                                            }

                                            td {
                                                padding: 16px 0;

                                                .type {
                                                    padding: 4px 8px;
                                                    -webkit-border-radius: 5px;
                                                    -moz-border-radius: 5px;
                                                    border-radius: 5px;
                                                    color: #3a4149;
                                                    font-weight: 700;

                                                    &.flex {
                                                        background-color: #abe390;
                                                    }

                                                    &.nb-iot {
                                                        background-color: #8ac8ff;
                                                    }

                                                    &.cat-m1 {
                                                        background-color: #ffc400;
                                                    }
                                                }

                                                &:first-child {
                                                    padding-left: 10px;
                                                }
                                                &:last-child {
                                                    padding-right: 10px;
                                                }

                                                .carrier-logo-box {
                                                    padding-right: 10px;
                                                    padding-bottom: 0;
                                                    border: none;

                                                    .carrier-logo {
                                                        height: 24px;
                                                        width: auto;
                                                        max-width: 100%;

                                                        &.light-mode {
                                                            display: block;
                                                        }
                                                        &.dark-mode {
                                                            display: none;
                                                        }
                                                    }
                                                }
                                            }
                                        }

                                        .cost-row {
                                            td {
                                                &:nth-child(7) {
                                                    text-align: right;
                                                }
                                                &:nth-child(6)::before,
                                                &:nth-child(7)::before {
                                                    content: '$ ';
                                                }
                                            }
                                        }

                                        .total-row {
                                            font-weight: 700;
                                            border: none;
                                            border-top: 2px solid;
                                            td {
                                                font-weight: 400;
                                                &:nth-child(4)::before {
                                                    content: '$ ';
                                                }
                                            }
                                        }
                                    }
                                }

                                .order-total {
                                    justify-content: space-between;
                                    align-items: center;
                                    padding: 0 0 20px 0;

                                    h3 {
                                        margin-bottom: 0;
                                    }
                                }
                                .re-attempt-payment-box {
                                    display: flex;
                                    justify-content: space-between;
                                    align-items: center;
                                    padding-top: 20px;
                                    border-bottom: none;
                                    span {
                                        color: #FC4D4D;
                                        font-size: 12px;
                                    }
                                    a {
                                        color: #4DA5FC;
                                        cursor: pointer;
                                    }
                                }

                                h4 {
                                    padding-left: 10px;
                                }
                                .order-tax,
                                .order-shipment,
                                .order-total {
                                    padding-left: 10px;
                                    padding-right: 10px;
                                }
                            }
                        }

                        .close-btn-box {
                            display: flex;
                            align-items: flex-end;
                            justify-content: flex-end;
                            padding: 20px;
                            border-top: 1px solid #c9cfd4;

                            .btn-close {
                                background-color: #f2f2f2;
                                border: none;
                                padding: 8px 20px;
                                font-weight: 700;
                                color: #2F353A;
                                -webkit-border-radius: 5px;
                                -moz-border-radius: 5px;
                                border-radius: 5px;
                                &:hover {
                                    background-color: #E4E5E6;
                                }
                            }
                        }

                        .loader-order-data {
                            position: absolute;
                            top: 0;
                            right: 0;
                            bottom: 0;
                            left: 0;

                            background-color: rgba(255, 255, 255, 0.7);

                            .sk-wave {
                                margin: 180px auto 20px;
                                height: 60px;
                                .sk-rect {
                                    width: 3px;
                                    background-color: #39c354;
                                    border-radius: 4px;
                                }
                            }

                            .text {
                                text-align: center;
                                font-size: 15px;
                                font-weight: 700;
                            }
                        }
                    }
                }
            }
        }
    }


.dark-theme {
    .order-details-modal {
        .modal-body {
            background-color: #3A4149;
            border-color: #1a1c1d;
            color: #fff;
            .content-modal {
                .flex-container {
                    .ordered-items {
                        .loader-order-data {
                            background-color: rgba(0, 0, 0, 0.4);
                        }
                        .temp-class {
                            .left-side {
                                .order-details-client {
                                    .change-card-button {
                                        .change-credit-cards-box {
                                            background-color: #3a4149;
                                            border: 1px solid #1a1c1d;
                                            .cc-list {
                                                .credit-card-select {
                                                    border: 1px solid #1a1c1d;
                                                    &:hover {
                                                        border-color: #0088ff;
                                                    }
                                                    .cc-nickname {
                                                        color: #a4a6a8;
                                                    }
                                                }
                                                .instruction {
                                                    color: #515B65;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .flex-container {
                    .ordered-items {
                        .temp-class {
                            .left-side {
                                border-color: #1a1c1d;
                                .status,
                                .order-details-client,
                                .trackingNumber {
                                    border-color: #1a1c1d;
                                }

                                .order-details-client,
                                .trackingNumber {
                                    background-color: #2f353a;
                                }

                            }
                            .right-side {
                                .summary-table-wrapper {
                                    border-color: #1a1c1d;
                                }
                                .summary-table {
                                    tbody {
                                        border-color: #1a1c1d;
                                        tr {
                                            &:nth-child(even) {
                                                background-color: #383e45;
                                            }
                                            td {
                                                .carrier-logo {
                                                    &.light-mode {
                                                        display: none;
                                                    }
                                                    &.dark-mode {
                                                        display: block;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                .order-tax,
                                .order-shipment,
                                .order-total {
                                    border-color: #1a1c1d;
                                }
                            }
                        }
                        .close-btn-box {
                            border-color: #1f2124;
                        }
                    }

                    .order-sim-number,
                    .control-buttons,
                    .addres-box-inner,
                    .btn-light {
                        background-color: #515b65;
                        border-color: #1a1c1d;
                        color: #EDEEEF;
                    }

                    .addres-container {
                        .addres-box {
                            .addres-box-inner {
                                background-color: #515b65;
                                border-color: #1a1c1d;
                            }
                        }
                        .new-shipment {
                            .btn-light{
                                border-color: #55cd6c;
                            }
                        }
                    }

                    .shipment-methods {
                        .shipment {
                            .card-wrap {
                                background: #515b65;
                                .cost {
                                    border-color: #3a4149;
                                }
                            }
                        }
                    }

                    .btn-outline-success {
                        background-color: #515b65;
                        color: #EDEEEF;
                        &:hover {
                            background-color: #55cd6c;
                        }
                    }

                    .container-fluid {
                        .summary {
                            background-color: transparent;
                            border-color: #2f353a;
                            .card-body {
                                background-color: transparent;
                            }
                        }
                    }

                    .payment-item {
                        background-color: #3a4149;
                    }

                    #add-credit-card {
                        .modal-content {
                            background-color: #3a4149;

                            .user-details {
                                color: #EDEEEF;
                            }

                            .modal-title,
                            .close {
                                color: #EDEEEF;
                            }

                            select,
                            input {
                                background-color: #2f353a;
                                border-color: #171a1e;
                                color: #EDEEEF;
                                &::placeholder {
                                    color: #EDEEEF;
                                }
                            }

                            .StripeElement {
                                background-color: #2f353a;
                                border-color: #171a1e;
                                .ElementsApp {
                                    input {
                                        color: #EDEEEF;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
